<template>
    <router-view />
</template>
<script lang="ts" setup>
definePageMeta({
  layout: 'admincp'
})

const store = $store()
const router = useRouter()
const user = store.userConfig.getUser
const userIsAdmin = computed<boolean>(() => !!user.isAdmin)
onMounted(() => {
  checkUserAdmin(userIsAdmin.value)
})

const checkUserAdmin = (val: boolean | undefined) => {
  if (!val) {
    router.push({ name: 'errors-access-denied' })
  }
}
</script>
